module.exports = __webpack_public_path__ + "static/media/19.1b520711.jpg";